function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var isSupported = typeof navigator !== 'undefined' && 'serviceWorker' in navigator;

function waitForServiceWorker() {
  return new Promise(function (resolve, reject) {
    if (!isSupported) {
      reject(new Error('Unsupported'));
    } else if (navigator.serviceWorker.controller) {
      // A serviceWorker is already registered and active.
      resolve();
    } else {
      navigator.serviceWorker.addEventListener('controllerchange', function () {
        resolve();
      });
    }
  });
}

var ServiceWorkerStore = /*#__PURE__*/function () {
  function ServiceWorkerStore(opts) {
    _classCallCheck(this, ServiceWorkerStore);

    this.ready = waitForServiceWorker();
    this.name = opts.storeName;
  }

  _createClass(ServiceWorkerStore, [{
    key: "list",
    value: function list() {
      var _this = this;

      var defer = {};
      var promise = new Promise(function (resolve, reject) {
        defer.resolve = resolve;
        defer.reject = reject;
      });

      var onMessage = function onMessage(event) {
        if (event.data.store !== _this.name) {
          return;
        }

        switch (event.data.type) {
          case 'uppy/ALL_FILES':
            defer.resolve(event.data.files);
            navigator.serviceWorker.removeEventListener('message', onMessage);
            break;

          default:
            defer.reject();
        }
      };

      this.ready.then(function () {
        navigator.serviceWorker.addEventListener('message', onMessage);
        navigator.serviceWorker.controller.postMessage({
          type: 'uppy/GET_FILES',
          store: _this.name
        });
      });
      return promise;
    }
  }, {
    key: "put",
    value: function put(file) {
      var _this2 = this;

      return this.ready.then(function () {
        navigator.serviceWorker.controller.postMessage({
          type: 'uppy/ADD_FILE',
          store: _this2.name,
          file: file
        });
      });
    }
  }, {
    key: "delete",
    value: function _delete(fileID) {
      var _this3 = this;

      return this.ready.then(function () {
        navigator.serviceWorker.controller.postMessage({
          type: 'uppy/REMOVE_FILE',
          store: _this3.name,
          fileID: fileID
        });
      });
    }
  }]);

  return ServiceWorkerStore;
}();

ServiceWorkerStore.isSupported = isSupported;
export default ServiceWorkerStore;